// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCheckbox-Text_cls1__cJLEe","cls2":"VeloCheckbox-Text_cls2__fBaJA VeloCheckbox-Text_cls1__cJLEe"};